import { useContext } from "react"
import { JWTContext } from "../contexts/JWTContext"

export const useAuth = () => useContext(JWTContext)
